<template>
    <v-card min-width="21vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h3>Send Email</h3></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 pt-7">
            <v-form v-model="valid">
                <p>Send email to <b>{{ user.user.firstName }} {{ user.user.lastName }}</b></p>
                <v-text-field label="Email Subject" placeholder="E.g. Welcome to Pro!" v-model="subject" :rules="subjectRule" outlined/>
                <v-textarea label="Email Message" placeholder="E.g. Today we want to..." auto-grow :rows="2" v-model="message" counter :rules="messageRule" outlined/>
                <br>
                <div class="mb-3">
                    <v-btn class="mr-5" @click="sendEmail">Send Email</v-btn>
                    <v-btn @click="closeWindow">Close</v-btn>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../repositories/users';
    export default {
        name: "SendEmail",
        props: {
            user: Object,
        },
        data() {
            return {
                subject: '',
                message: '',

                // Rules
                valid: false,
                subjectRule: [
                    s => !!s || 'Subject is required',
                ],
                messageRule: [
                    m => !!m || 'Message is required',
                ],
            };
        },
        methods: {
            sendEmail() {
                if(this.valid) {
                    let emailNeeds = {
                        email: this.user.user.email,
                        name: this.user.user.firstName,
                        subject: this.subject,
                        message: this.message,
                    };
                    Repository.sendEmail(emailNeeds).then((response) => {
                        if(response.status < 400 && response.data) {
                            alert('Email was successfully sent.')
                            this.closeWindow();
                        }
                    });
                }
                else
                    alert('Fill all the mandatory fields.');
            },
            closeWindow() {
                this.$emit('closeWindow');
            },
        }
    }
</script>

<style scoped>

</style>
